<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('how_to_order')"/>
        <div class="card">
            <div class="card-body">
               <div v-if="preloader" class="text-center">
                   <app-pre-loader />
               </div>
                <form v-else method="post"
                      ref="form"
                      data-url="/admin/api/how-to-order"
                      @submit.prevent="submitData">
                    <app-input
                            type="text-editor"
                            v-model="formData.content"
                            placeholder="Content"
                            :errorMessage="$errorMessage(errors, 'content')"
                    />
                    <div class="form-group mt-3">
                        <submit-button
                                :label="$t('save')"
                                :loading="loading"
                                @click="submitData"
                        />
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import FormHelperMixin from "../../../Mixins/FormHelperMixin";
    import {axiosGet} from "../../../Helpers/AxiosHelper";
    import SubmitButton from "../../Helpers/Button/SubmitButton";

    export default {
        name: "HowToOrder",
        components: {SubmitButton},
        mixins: [FormHelperMixin],
        methods: {
            getHowToOrder() {
                this.preloader = true;
                return axiosGet('/admin/api/how-to-order')
                    .then(response => {
                        this.formData.content = response.data;
                    }).finally(() => {
                        this.preloader = false;
                    });
            },
            afterSuccess({data}) {
                this.toastAndReload(data.message);
            }
        },
        created() {
            this.getHowToOrder();
        }
    }
</script>

<style>
    .note-group-select-from-files {
        display: none;
    }
</style>